import { HttpClient, HttpHeaders } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { $app } from '@app/app.service'
import { DataService } from '@data/service/data.service'
import { ConfigService } from '@core/config.service'

@Injectable()
export class AppBasicService {
   console: boolean = $app.core.modeDevel
   logPrefix: string = '@service - ' + this.constructor.name

   public _configService = inject(ConfigService)

   public httpOptions: any = {
      headers: new HttpHeaders({
         'Content-Type': 'application/json',
         'Cache-Control': 'no-cache',
         Pragma: 'no-cache',
      }),
   }

   public http: HttpClient
   public dataSrv: DataService

   constructor(
      public httpRef: HttpClient,
      public dataSrvRef: DataService
   ) {
      this.http = httpRef
      this.dataSrv = dataSrvRef
   }
}
